<template>
  <div>
    <div v-if="loading">
      <slot name="loading">
        <div class="my-10 text-center">A carregar...</div>
      </slot>
    </div>
    <div v-else-if="enabled">
      <slot name="enabled"> Feature ativa </slot>
    </div>
    <div v-else>
      <slot name="disabled"> Feature inativa </slot>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    feature: String,
  },

  data() {
    return {
      loading: true,
      enabled: null,
    };
  },

  methods: {
    async verifyFeature() {
      this.loading = true;

      try {
        this.enabled = await this.$store.dispatch(
          "feature_flags/check",
          this.feature
        );
      } catch (error) {
        console.error(error);
        this.enabled = false;
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {},

  created() {
    this.verifyFeature();
  },
};
</script>
